<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.USERS)}}</h2>
  <div class="card mb-2">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="user-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="user-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="search-grid">
          <div class="search-field">
            <label>{{_(KEYS.GRID.USERNAME)}}</label>
            <input class="form-control" [(ngModel)]="filter.email">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.FIRSTNAME)}}</label>
            <input class="form-control" [(ngModel)]="filter.firstName">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.LASTNAME)}}</label>
            <input class="form-control" [(ngModel)]="filter.lastName">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.COMPANY)}}</label>
            <input class="form-control" [(ngModel)]="filter.company">
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-user-table-export></app-user-table-export>

  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="user-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.USERS)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="user-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="id-col">{{_(KEYS.GRID.ID)}}</th>
            <th>{{_(KEYS.GRID.USERNAME_MAIL)}}</th>
            <th>{{_(KEYS.GRID.NAME)}}</th>
            <th>{{_(KEYS.GRID.ADDRESS)}}</th>
            <th>{{_(KEYS.GRID.COMPANY)}}</th>
            <th>{{_(KEYS.GRID.UPDATED_AT)}}</th>
            <th>{{_(KEYS.GRID.UPDATED_BY)}}</th>
            <th>{{_(KEYS.GRID.OPTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let user of getUsers(); let pos = index;">
            <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}" *ngIf="isOnCurrentPage(pos)">
              <td class="id-col">
                <span>{{user.userId}}</span>
              </td>
              <td>
                {{user.email}}
              </td>
              <td>
                <ng-container *ngIf="user.data">
                  <!--
                  <span *ngIf="user.data.gender && user.data.gender === 'male'">Herr </span>
                  <span *ngIf="user.data.gender && user.data.gender === 'female'">Frau </span>
                  -->
                  <span *ngIf="user.data.title">{{user.data.title}} </span>
                  <span *ngIf="user.data.firstName">{{user.data.firstName}} </span>
                  <span *ngIf="user.data.firstName">{{user.data.lastName}}</span>
                  <span *ngIf="user.data.firstname && !user.data.firstName">{{user.data.firstname}} </span>
                  <span *ngIf="user.data.lastname && !user.data.lastName">{{user.data.lastname}}</span>
                </ng-container>
              </td>
              <td>
                <ng-container *ngIf="user.data">
                  <span *ngIf="user.data.street">{{user.data.street}}, </span>
                  <span *ngIf="user.data.country">{{user.data.country}}-</span><span *ngIf="user.data.zip">{{user.data.zip}} </span>
                  <span *ngIf="user.data.city">{{user.data.city}}</span>
                </ng-container>
              </td>
              <td>
                {{user.company}}
              </td>
              <td>
                {{user.lastChangeAt | datex:dateFormat}}
              </td>
              <td>
                {{user.lastChangeBy}}
              </td>
              <td>
                <div class="d-inline-block nowrap">
                  <div
                    class="btn btn-primary d-inline-block mr-1"
                    [routerLink]="'/module/ums/user/crud/' + user.userId"
                    ngbTooltip="{{_(KEYS.GRID.CHANGE)}}"
                  >
                    <i class="fa fa-edit qa-cursor-pointer"></i>
                  </div>
                  <button
                    type="button"
                    class="btn btn-primary d-inline-block mr-1"
                    (click)="onResetPassword(user)"
                    [attr.disabled]="user.email === 'admin@mymedax.de' || user.email === 'allocator@mymedax.de' ? true : null"
                    ngbTooltip="{{_(KEYS.GRID.RESET_PASSWORD)}}"
                  >
                    <i class="fa fa-envelope-o"></i>
                  </button>
                  <div
                    class="btn btn-danger d-inline-block mr-1"
                    (click)="onDeleteUser(user)"
                    ngbTooltip="{{_(KEYS.GRID.DELETE)}}"
                  >
                    <i class="fa fa-trash qa-cursor-pointer"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>

        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="getUsers().length"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>

      </div>
    </div>
  </div>
</div>
